<div class="vh-100 d-flex flex-column">
  <div class="content-wrapper">
    <app-navbar
      [logoLightPath]="logo.light"
      [logoDarkPath]="logo.dark"
    ></app-navbar>
  </div>

  <div class="flex-grow-1 content-background w-100">
    <div class="content-wrapper">
      <router-outlet></router-outlet>
    </div>
  </div>

  <div class="content-wrapper">
    <app-dynamic-footer [links]="filteredFooterLinks"></app-dynamic-footer>
  </div>
</div>
